import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTokens, setTokens } from "../../utils";
import { API_PATH, login } from "../../services/auth";

const initialState = {
  user: getTokens().auth
};

export const loginAuth = createAsyncThunk(`${API_PATH}/login`, async user => {
  const res = await login(user);
  return res;
});
export const userSlice = createSlice({
  name: API_PATH,
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload;
    }
  },
  extraReducers: {
    [loginAuth.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const user = payload.data.data;
        setTokens(user.accessToken, user.accessToken);
        state.user = user;
      }
    }
  }
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
